import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useLocation } from "react-router-dom";
import { Global } from "../../../Variables/Global";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Cookies from "js-cookie";
import { Modal } from "react-bootstrap";

const Checkout = (props) => {
  const [sessionId, setSessionId] = useState("");
  const [orderNumber, setOrderNumber] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);
  const [bankFees, setBankFees] = useState(0);
  const [PhoneNumber, setPhoneNumber] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [Address1, setAddress1] = useState("");
  const [Address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [cityId, setCityId] = useState("");
  const [Notes, setNotes] = useState("Your Notes");
  const [key, setKey] = useState("home");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const navigate = useNavigate();

  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  const getCartItems = async () => {
    var groupId;
    if (Cookies.get("WishList") != undefined) {
      groupId = 4;
    } else {
      groupId = 3;
    }
    const offset = new Date().getTimezoneOffset();
    var CartId = Cookies.get("Cart");
    const token = Cookies.get("CustomerToken");
    fetch(
      Global.API_URL +
      "Cart/GetCartItems/" +
      CartId +
      "/" +
      offset +
      "/" +
      125 +
      "/" +
      groupId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((Result) => {
        setCartCount(Result.Count);
        setCartItems(Result.CartItems);
        let totalPrice = 0;
        Result.CartItems.forEach((item) => {
          var price = item.IsPreOrder ? item.PreOrderPrice : (item.SalePrice != 0 ? item.SalePrice : item.RegularPrice);
          totalPrice += price * item.Quantity;
        });
        setBankFees((totalPrice * 0.035).toFixed(2))
        setTotalPrice(totalPrice);
      })
      .catch((error) => {
        console.error('Error fetching cart items:', error);
      });
  };

  useEffect(() => {
    getCartItems();
  }, []);

  const getAddressBookDetailsHome = () => {
    const CustomerId = Cookies.get("Number");
    const token = Cookies.get("CustomerToken");
    fetch(
      Global.API_URL +
      "AddressBook/GetOrderAddressBookByAddressType/" +
      key +
      "/" +
      CustomerId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return Response.text().then((text) => {
          throw new Error(text);
        });
      })
      .then((Result) => {
        setAddress1(Result.Address1);
        setAddress2(Result.Address2);
        setFirstName(Result.FirstName);
        setLastName(Result.LastName);
        setPhoneNumber(Result.PhoneNumber);
        setEmail(Result.Email);
        fetch(Global.API_URL + "Country/GetCitiyNameById/" + Result.CityId, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": Global.API_URL,
          },
        })
          .then((response) => {
            return response.json();
          })
          .then((Result) => {
            setCity(Result[0].CityName);
            setCityId(Result[0].CityId);
          });
      })
      .catch((error) => {
        if (error.message.replaceAll('"', "") === "Address book not found") {
        }
      });
  };

  const getTotal = (items) => {
    var totall = 0;
    const total = items.reduce((total, currentItem) => {
      if (currentItem.SalePrice != 0) {
        totall = totall + currentItem.SalePrice * currentItem.Quantity;
      } else {
        totall = totall + currentItem.RegularPrice * currentItem.Quantity;
      }
    }, 0);
    setTotal(totall);
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    if (paymentMethod == '') {
      toast.error("Select a payment method");
    } else {
      setButtonDisabled(true);
      toast.success("Your Order is being procceed. Please wait.");
      var groupId;
      if (Cookies.get("WishList")) {
        groupId = 4;
      } else {
        groupId = 3;
      }
      const offset = new Date().getTimezoneOffset();
      const CartId = Cookies.get("Cart");
      const token = Cookies.get("CustomerToken");
      fetch(
        Global.API_URL +
        "Order/CreateOrder?" +
        new URLSearchParams({
          CartId: CartId,
          Currency: "Dollar",
          CustomerUsername: `${FirstName + " " + LastName}`,
          Email: Email,
          PhoneNumber: PhoneNumber,
          Address1: Address1,
          Address2: Address2,
          CityId: cityId,
          IsDefault: false,
          IsSamePerson: false,
          Notes: Notes,
          Offset: offset,
          GroupId: groupId,
          CountryCode: "LB",
          CountryId: 125,
          PostalCode: "00000",
          State: "Lebanon",
          AddressType: key,
          PaymentMethodId: paymentMethod == 'delivery' ? 0 : 1,
          Mobile: "0"
        }),
        {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      ).then(async (response) => {
        if (response.ok) {
          toast.success("Order Successfuly Compeleted");
          return response.json();
        }
        else {
          const errrorMesage = await response.text();
          toast.error(errrorMesage);
        }
      }).then((response) => {

        if (paymentMethod != 'delivery') {
          setSessionId(response.SessionId);
          setOrderNumber(response.OrderNumber);
          handleShowModal();
        }
        else {
          if (response != null) {
            navigate(`/Cart?OrderId=${response.OrderNumber}`);
          }
        }
      });
    }
  };

  useEffect(() => {
    sessionStorage.clear();
    if (Cookies.get("CustomerToken") === undefined) {
      navigate("/UserAuthentication");
    } else {
      props.setHeaderTitle("Checkout");
      props.setFooterActive(3);
      getAddressBookDetailsHome();
      getTotal(cartItems);
    }

    if (window.Checkout) {
      // Initialize Checkout with the obtained session ID
      window.Checkout.configure({
        session: {
          id: sessionId
        }
      });
    } else {
      console.error("Checkout.js is not loaded.");
    }
  }, [key, sessionId]);


  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    const isCancelled = window.confirm("Are you sure you want to cancel the order?");
    if (isCancelled) {
      setShowModal(false);
      sessionStorage.clear();
      navigate("/Cart");
      const token = Cookies.get("CustomerToken");
      return fetch(Global.API_URL + "Order/UpdateOrderStatus", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          OrderId: orderNumber,
          OrderStatusId: 7
        }),
      })
        .then((response) => response.json())
        .then((data) => {
        })
        .catch((error) => {
          console.error('Error updating order status:', error);

        });
    }
  };

  const handleModalShown = () => {

    window.Checkout.showEmbeddedPage("#hco-embedded");
  };

  return (
    <>

      <div>


        <Modal show={showModal} onHide={handleCloseModal} onShow={handleModalShown}>
          <Modal.Header closeButton>
            <Modal.Title>Play Megastore SARL</Modal.Title>
          </Modal.Header>
          <Modal.Body id="hco-embedded">
          </Modal.Body>
          <Modal.Footer>
            <img style={{ width: "100px", height: "100px" }} src="https://www.netcommercepay.com/logo/NCseal_S.gif" border="0" alt="NetCommerce Security Seal"></img>

          </Modal.Footer>
        </Modal>
      </div>


      <div className="container Checkout">
        <div className="row d-none d-md-block">
          <div className="col-12 col-md-12">
            <ul className="bread-crumb">
              <li>Home</li>
              <li>/</li>
              <li>
                <Link to="/Cart">Cart /</Link>
              </li>
              <li>Checkout</li>
            </ul>
          </div>
        </div>
        <div className="row d-none d-md-block">
          <div className="col-12 col-md-12">
            <h1>Checkout</h1>
          </div>
        </div>
        <form onSubmit={handleCheckout}>
          <div className="row">
            <div className="col-md-12 col-lg-9 Profile">
              <div className="infoBox mt-0">
                <Tabs
                  activeKey={key}
                  id="controlled-tab-example"
                  className="mb-3"
                  onSelect={(k) => setKey(k)}
                >
                  <Tab eventKey="home" title="Home">
                    <div className="row">
                      <div className="col-12">
                        <label className="title mb-0">
                          1 Personal Information
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Full Name:</label>
                      </div>
                      <div className="col-9">
                        <div className="row">
                          <div className="col-6">
                            <input
                              type="text"
                              value={FirstName}
                              className="inputBox"
                              placeholder="First Name"
                              onChange={(e) => setFirstName(e.target.value)}
                              required
                            />
                          </div>
                          <div className="col-6">
                            <input
                              type="text"
                              value={LastName}
                              className="inputBox"
                              placeholder="Last Name"
                              onChange={(e) => setLastName(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Email</label>
                      </div>
                      <div className="col-9">
                        <input
                          type="email"
                          value={Email}
                          className="inputBox"
                          placeholder="Your Email"
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Phone Number</label>
                      </div>
                      <div className="col-9">
                        <div className="col-12">
                          <PhoneInput
                            placeholder="Type here"
                            className="inputBox"
                            value={PhoneNumber}
                            onChange={setPhoneNumber}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-12">
                        <label className="title">2 Address</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Address1:</label>
                      </div>
                      <div className="col-9">
                        <input
                          type="text"
                          className="inputBox"
                          value={Address1}
                          placeholder="Type Here"
                          onChange={(e) => setAddress1(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">City:</label>
                      </div>
                      <div className="col-9">
                        <select
                          className="inputBoxSelect"
                          onChange={(e) => {
                            setCity(e.target.name);
                            setCityId(e.target.value);
                          }}
                        >
                          <option className="info" value={cityId}>
                            {city.length > 0 ? city : "Choose a city"}
                          </option>
                          <option className="info" value="16124">
                            North
                          </option>
                          <option className="info" value="16125">
                            South
                          </option>
                          <option className="info" value="16126">
                            Beirut
                          </option>
                          <option className="info" value="16127">
                            Mont-Liban
                          </option>
                          <option className="info" value="16128">
                            Bekaa
                          </option>
                          <option className="info" value="16129">
                            Nabatieh
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Address2:</label>
                      </div>
                      <div className="col-9">
                        <textarea
                          placeholder="Type Address"
                          value={Address2}
                          className="textareaBox"
                          cols="4"
                          rows="3"
                          onChange={(e) => setAddress2(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-12">
                        <label className="title">4 Note</label>
                      </div>
                    </div>
                    <div className="col-3">
                      <label className="infoTitle">Notes:</label>
                    </div>
                    <div className="col-9">
                      <input
                        type="text"
                        className="inputBox"
                        value={Notes}
                        placeholder="Type Here"
                        onChange={(e) => setNotes(e.target.value)}
                        required
                      />
                    </div>
                    <hr />
                  </Tab>
                  <Tab eventKey="work" title="Work">
                    <div className="row">
                      <div className="col-12">
                        <label className="title mb-0">
                          1 Personal Information
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Full Name:</label>
                      </div>
                      <div className="col-9">
                        <div className="row">
                          <div className="col-6">
                            <input
                              type="text"
                              className="inputBox"
                              value={FirstName}
                              placeholder="First Name"
                              onChange={(e) => setFirstName(e.target.value)}
                              required
                            />
                          </div>
                          <div className="col-6">
                            <input
                              type="text"
                              className="inputBox"
                              value={LastName}
                              placeholder="Last Name"
                              onChange={(e) => setLastName(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Email</label>
                      </div>
                      <div className="col-9">
                        <input
                          type="email"
                          className="inputBox"
                          value={Email}
                          placeholder="Your Email"
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Phone Number</label>
                      </div>
                      <div className="col-9">
                        <div className="col-12">
                          <PhoneInput
                            placeholder="Type here"
                            className="inputBox"
                            value={PhoneNumber}
                            onChange={setPhoneNumber}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-12">
                        <label className="title">2 Address</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Address1:</label>
                      </div>
                      <div className="col-9">
                        <input
                          type="text"
                          className="inputBox"
                          value={Address1}
                          placeholder="Type Here"
                          onChange={(e) => setAddress1(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">City:</label>
                      </div>
                      <div className="col-9">
                        <select
                          className="inputBoxSelect"
                          onChange={(e) => {
                            setCity(e.target.name);
                            setCityId(e.target.value);
                          }}
                        >
                          <option className="info" value={cityId}>
                            {city.length > 0 ? city : "Choose a city"}
                          </option>
                          <option className="info" value="16124">
                            North
                          </option>
                          <option className="info" value="16125">
                            South
                          </option>
                          <option className="info" value="16126">
                            Beirut
                          </option>
                          <option className="info" value="16127">
                            Mont-Liban
                          </option>
                          <option className="info" value="16128">
                            Bekaa
                          </option>
                          <option className="info" value="16129">
                            Nabatieh
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <label className="infoTitle">Address2:</label>
                      </div>
                      <div className="col-9">
                        <textarea
                          placeholder="Type Address"
                          value={Address2}
                          className="textareaBox"
                          cols="4"
                          rows="3"
                          onChange={(e) => setAddress2(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-12">
                        <label className="title">4 Note</label>
                      </div>
                    </div>
                    <div className="col-3">
                      <label className="infoTitle">Notes:</label>
                    </div>
                    <div className="col-9">
                      <input
                        type="text"
                        className="inputBox"
                        value={Notes}
                        placeholder="Type Here"
                        onChange={(e) => setNotes(e.target.value)}
                        required
                      />
                    </div>
                    <hr />
                  </Tab>
                </Tabs>
                <div className="row mt-25 mb-30">
                  <div className="col-12 fontOverride">
                  </div>
                </div>
                <>
                </>
              </div>
            </div>
            <div className="col-md-12 col-lg-3 Profile">
              <div className="infoBox mt-0">
                <div className="row mb-30">
                  <div className="col-12">
                    <label className="sideTitlep">
                      {cartCount} {cartCount > 1 ? "Items" : "Item"}
                    </label>
                  </div>
                </div>
                {cartItems.map((item) => {
                  return (
                    <div key={item.ProductId} className="row mb-50">
                      <div className="col-4" style={{ position: "relative" }}>
                        <img
                          src={Global.PHOTO_URL + item.Image}
                          className="CheckoutImg"
                          alt={item.ProductName}
                        />

                        {item.IsPreOrder && (
                          <div
                            style={{
                              position: "absolute",
                              top: "30px",
                              left: "5px",
                              backgroundColor: "rgba(208, 18, 20, 0.7)",
                              color: "#fff",
                              padding: "5px 20px",
                              fontSize: "0.50rem",
                              fontWeight: "bold",
                              transform: "rotate(-45deg)",
                              borderRadius: "4px",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
                            }}
                          >
                            PRE-ORDER
                          </div>
                        )}
                      </div>
                      <div className="col-8">
                        <p className="itemName">
                          {item.ProductName}
                          <span> x{item.Quantity}</span>
                        </p>

                        {/* Attributes list */}
                        <p
                          className="itemDesc mb-2"
                          style={{
                            whiteSpace: "pre-line",
                            fontSize: "0.85rem",
                            color: "#6c757d"
                          }}
                        >
                          {item.assignedAttributes
                            .map(a => `• ${a.AttributeName}: ${a.AttributeValueName}\n`)
                            .join("")}
                        </p>

                        {/* Prices */}
                        {item.IsPreOrder > 0 ? (
                          <span className="itemPrice float-end">
                            ${item.PreOrderPrice * item.Quantity}
                          </span>
                        ) : item.SalePrice === 0 ? (
                          <span className="itemPrice float-end">
                            ${item.RegularPrice * item.Quantity}
                          </span>
                        ) : (
                          <span className="itemPrice float-end">
                            ${item.SalePrice * item.Quantity}
                          </span>
                        )}
                      </div>

                    </div>
                  );
                })}
                <hr />
                {paymentMethod === 'online' ?
                  <div className="row">
                    <p className="itemName" style={{ textAlignLast: "right", color: "black" }}>
                      Bank Fees (3.5%)
                      <span> {Math.ceil(bankFees)}</span>
                    </p>
                  </div>
                  : null}

                <div className="row">
                  <p className="itemName" style={{ textAlignLast: "right", color: "black" }}>
                    Total
                    <span> ${paymentMethod === 'online' ? (parseFloat(Math.ceil(totalPrice)) + Math.ceil(bankFees)) : totalPrice}</span>
                  </p>
                </div>
                <div>
                  {cartCount > 0 && (
                    <div>
                      <h5>Select Payment Method:</h5>

                      {cartItems.some(item => item.IsPreOrder) ? (
                        // ✅ Show only online if any item is preorder
                        <div>
                          <label className="payment-option">
                            <input
                              type="radio"
                              value="online"
                              checked={paymentMethod === "online"}
                              onChange={handlePaymentMethodChange}
                              className="payment-radio"
                            />
                            Pay Online
                          </label>
                        </div>
                      ) : (
                        // ✅ Otherwise show both options
                        <>
                          <div>
                            <label className="payment-option">
                              <input
                                type="radio"
                                value="online"
                                checked={paymentMethod === "online"}
                                onChange={handlePaymentMethodChange}
                                className="payment-radio"
                              />
                              Pay Online
                            </label>
                          </div>
                          <div>
                            <label className="payment-option">
                              <input
                                type="radio"
                                value="delivery"
                                checked={paymentMethod === "delivery"}
                                onChange={handlePaymentMethodChange}
                                className="payment-radio"
                              />
                              Cash on Delivery
                            </label>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <button
                    disabled={buttonDisabled}
                    className="outBtn"
                  >
                    Checkout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default Checkout;
